import React from 'react'
import ZoomMap from './primitives/ZoomMap'

/**
 * Zoom Map with visible buttons
 */
class Block7 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { t } = this.props
        return (
            <div className={`block __${t}`}>
                <ZoomMap {...this.props}></ZoomMap>
            </div>
        )
    }
}

export default Block7
